<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import SelfFetchingBrowseBy from "@shared/svelte/Components/BrowseBy/SelfFetchingBrowseBy.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { NoProductLinesAvailableEntity } from "@shared/services/event_tracking/entities";

  const { trackMrcEvents, trackClick } = EventTracking;

  export let stateParams;

  $: hasSelectedFilters = $ProductLineListingStore.selectedFilters?.length;
  $: mobileMode = $LayoutStore.isMobile;
  $: topHeadingClass = mobileMode ? "fizz-heading-3" : "fizz-heading-2";

  let showSelectRetailer = false;
  const trackingParams = new NoProductLinesAvailableEntity();
</script>

<div
  data-testid="no-product-lines-match"
  class="fizz-flex-row fizz-justify-center fizz-inset-square-16"
>
  <TrackingContext entities={trackingParams} let:trackingContext>
    <div class="fizz-flex-vertical">
      <div use:trackMrcEvents={[trackingContext.entities]}>
        {#if hasSelectedFilters}
          <div class="fizz-flex-row fizz-stack-24 fizz-justify-center">
            <div class={topHeadingClass}>
              We're sorry, there are no items that match your selected filters.
            </div>
          </div>
          <div class="fizz-flex-row fizz-justify-center fizz-stack-24">
            <div class:fizz-heading-4={!mobileMode}>
              Please adjust your filters or explore our other product categories.
            </div>
          </div>
        {:else if stateParams.search}
          <div class="fizz-flex-row fizz-stack-24 fizz-justify-center">
            <div class={topHeadingClass}>
              It looks like there aren't any items that match your search.
            </div>
          </div>
          <div class="fizz-flex-row fizz-justify-center fizz-stack-24">
            <div class:fizz-heading-4={!mobileMode}>
              Take a moment to explore our categories listed below in order to find what you're
              looking for.
            </div>
          </div>
          <div class="fizz-flex-row fizz-justify-center fizz-stack-24">
            <a
              href={"/product_listing"}
              data-testid="discover-more-products-button"
              class="fizz-button-secondary fizz-inline-block"
              on:click={() => {
                trackClick("plp_no_products_discover_more_products", trackingContext.entities);
              }}
            >
              Discover more products
            </a>
          </div>
        {:else}
          <div class="fizz-flex-row fizz-stack-24 fizz-justify-center">
            <div class={topHeadingClass}>
              It looks like there are no products available in your specific market.
            </div>
          </div>
        {/if}
      </div>

      <SelfFetchingBrowseBy forceWhiteBackground={true} />
    </div>
  </TrackingContext>
</div>
